import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { useForm } from 'react-hook-form'
import classnames from 'classnames'

import { onLeadMagnetFunnelFormDispatch as dispatchSelector } from 'reduxModules/leadMagnetPages/dispatchers'
import { leadMagnetPageStateSelector as stateSelector } from 'reduxModules/leadMagnetPages/selectors'

import '../../../generic/RenderedField/styles.css'
import './styles.css'

const EMAIL_PATTERN = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i

export function LeadMagnetFunnelForm({
  hasSubscription,
  isPopUp = false,
  tag,
  formValues = { newsletter: false, isCTADisabled: false },
  toggleNewsletter,
  onSubmit
}) {
  const {
    register,
    handleSubmit,
    formState: { errors, isDirty }
  } = useForm()

  if (hasSubscription) return null

  return (
    <section id="LeadMagnetFunnelForm" className={isPopUp ? 'popup' : ''}>
      <div className="internal-container wrapper">
        <div className="copy">
          <h2 className="title">
            Get FREE Popular Course Content!
          </h2>
          <div className="subtitle">
            <p className="tagline">
              Enter your email for FREE access to content from 16 of our most popular courses.
            </p>
          </div>
        </div>
        <div className="form">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className={classnames('field', { '-error': errors.email })}>
              <div className="field-container">
                <input
                  {...register('email', {
                    pattern: {
                      value: EMAIL_PATTERN,
                      message: 'Invalid email address.'
                    }
                  })}
                  type="email"
                  placeholder="Email"
                  aria-label="Email"
                  key={`${tag}-email-field`}
                />
                <span
                  className={`field__error${!errors.email ? ' field__error--hidden' : ''}`}
                  role="alert"
                >
                  {errors.email?.message}
                </span>
              </div>
            </div>
            <div className="newsletter" style={{ marginBottom: formValues.newsletter ? '28px' : 0 }}>
              <div className="checkbox-area">
                <div className="checkbox-confirm">
                  <input
                    type="checkbox"
                    name="newsletter"
                    checked={formValues.newsletter}
                    value={formValues.newsletter}
                    id="newsletter-checkbox"
                    onChange={() => toggleNewsletter()}
                  />
                  <label htmlFor="newsletter-checkbox">I agree to receive email updates</label>
                </div>
              </div>
            </div>
            {!formValues.newsletter && (
              <div className="warning">
                <p className="danger">You need to agree to receive updates</p>
              </div>
            )}
            <button
              type="submit"
              className="btn -wide -blue-2"
              disabled={!isDirty || formValues.isCTADisabled || !formValues.newsletter}
              aria-label="Enter your email and click submit to receive your free content"
            >
              Get Free Access
            </button>
          </form>
        </div>
      </div>
    </section>
  )
}

LeadMagnetFunnelForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  tag: PropTypes.string.isRequired,
  isPopUp: PropTypes.bool,
  hasSubscription: PropTypes.bool,
  formValues: PropTypes.shape({
    newsletter: PropTypes.bool,
    isCTADisabled: PropTypes.bool
  }),
  toggleNewsletter: PropTypes.func
}

export default connect(
  stateSelector,
  null,
  dispatchSelector
)(LeadMagnetFunnelForm)
